import "./style.scss";
import * as React from "react";
import { Table as AntDTable } from "antd";

class Table extends React.Component<any, any> {
  render() {
    return <AntDTable {...this.props}></AntDTable>;
  }
}

export default Table;



// WEBPACK FOOTER //
// ./client/modules/core/Table/index.tsx